import apiClient from "../api/apiClient";

export interface ConfirmResponse {
  status: "confirmed";
}

export interface CancelResponse {
  status: "cancelled";
  replay?: boolean;
}

export interface RescheduleResponse {
  status: "rescheduled";
  new_event_id?: string;
  replay?: boolean;
}

export interface RescheduleContext {
  event_id: string;
  business_id: string;
  business_name: string;
  service_id: number;
  service_description: string | null;
  customer_name: string;
  current_start_time: string;
  current_end_time: string;
}

class ReminderActionsService {
  private baseApiUrl = process.env.REACT_APP_BACKEND_API;

  async confirm(token: string): Promise<ConfirmResponse> {
    const response = await apiClient.post<ConfirmResponse>(
      `${this.baseApiUrl}/api/reminders/action/confirm`,
      { token },
    );
    return response.data;
  }

  async cancel(token: string): Promise<CancelResponse> {
    const response = await apiClient.post<CancelResponse>(
      `${this.baseApiUrl}/api/reminders/action/cancel`,
      { token },
    );
    return response.data;
  }

  async reschedule(
    token: string,
    newStartTime: string,
    newEndTime: string,
  ): Promise<RescheduleResponse> {
    const response = await apiClient.post<RescheduleResponse>(
      `${this.baseApiUrl}/api/reminders/action/reschedule`,
      {
        token,
        new_start_time: newStartTime,
        new_end_time: newEndTime,
      },
    );
    return response.data;
  }

  async getRescheduleContext(token: string): Promise<RescheduleContext> {
    const response = await apiClient.get<RescheduleContext>(
      `${this.baseApiUrl}/api/reminders/reschedule-context`,
      { params: { token } },
    );
    return response.data;
  }
}

export const reminderActionsService = new ReminderActionsService();
